// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function orderTypeToString(orderType) {
  switch (orderType) {
    case /* Missed */0 :
        return "Missed";
    case /* ABRTG */1 :
        return "ABRTG";
    case /* Completed */2 :
        return "Completed";
    case /* Fraud */3 :
        return "Fraud";
    case /* NotEligible */4 :
        return "Not Eligible";
    
  }
}

function getTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Order ID"
            },
            accessor: (function (order) {
                var data = order.order_id;
                if (data !== undefined) {
                  return {
                          TAG: /* Text */0,
                          _0: data
                        };
                } else {
                  return {
                          TAG: /* Text */0,
                          _0: "N/A"
                        };
                }
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Order Type"
              },
              accessor: (function (order) {
                  return {
                          TAG: /* Text */0,
                          _0: orderTypeToString(order.order_type)
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Order Date"
                },
                accessor: (function (order) {
                    var date = order.order_date;
                    return {
                            TAG: /* Text */0,
                            _0: date !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(date), "DD/MM/YYYY") : "N/A"
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function CampaignOrdersListTable(Props) {
  var tableData = Props.tableData;
  return React.createElement("div", {
              className: "table-wrapper"
            }, List.length(tableData) === 0 ? React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: ErrorUtils$Catalyst.getDefaultErrorEntity("No orders done by the partner", undefined, undefined)
                  }) : React.createElement(TableComponent$Catalyst.make, {
                    columns: getTableColumnsSchema(undefined),
                    rowData: tableData,
                    className: "customTable"
                  }));
}

var make = CampaignOrdersListTable;

export {
  orderTypeToString ,
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
